import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import logo from '../logo.png';

const BackgroundAnimation = () => {
    const [elements, setElements] = useState([]);

    useEffect(() => {
        // Generate random starting positions and delays
        const newElements = Array.from({ length: 20 }).map((_, i) => ({
            id: i,
            type: Math.random() > 0.5 ? 'image' : 'text',
            x: Math.random() * window.innerWidth,
            y: Math.random() * window.innerHeight,
            delay: Math.random() * 5,
            duration: 10 + Math.random() * 10,
            size: 30 + Math.random() * 40,
        }));
        setElements(newElements);
    }, []);

    return (
        <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
            {elements.map((el) => {
                const commonProps = {
                    key: el.id,
                    className: "absolute opacity-5",
                    style: {
                        left: el.x,
                        top: el.y,
                        ...(el.type === 'image' ? { width: el.size, height: el.size } : { fontSize: el.size }),
                    },
                    animate: {
                        x: [0, 100, 100, 0, 0],
                        y: [0, 0, 100, 100, 0],
                        rotate: [0, 90, 180, 270, 360],
                    },
                    transition: {
                        duration: el.duration,
                        ease: "linear",
                        repeat: Infinity,
                        delay: el.delay,
                    },
                };

                if (el.type === 'image') {
                    return (
                        <motion.img
                            {...commonProps}
                            src={logo}
                            alt=""
                        />
                    );
                }

                return (
                    <motion.div
                        {...commonProps}
                        className="absolute opacity-5 font-bold text-white whitespace-nowrap select-none"
                    >
                        $TITSTR
                    </motion.div>
                );
            })}
        </div>
    );
};

export default BackgroundAnimation;
